import React, { useState, useEffect } from 'react';

import { getRequest } from 'utils/api';
import useIsBuyer from 'hooks/useIsBuyer';
import Matches from './Matches';

const FeaturedMatches = ({ updateFollowingList }) => {
  const [featuredMatchList, setFeaturedMatchList] = useState([]);
  const [hasMoreFeaturedMatches, setHasMoreFeaturedMatches] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isBuyer = useIsBuyer();

  const updateFeaturedMatchGig = gig => {
    setFeaturedMatchList(prevState => prevState.map(g => (g.id === gig.id ? gig : g)));

    updateFollowingList(gig);
  };

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    getRequest({
      endpoint: 'gigs/featured',
      query: { per_page: 5 },
      resolveResponse: true,
    })
      .then(response => {
        const data = response.status === 204 ? [] : [...response.data.gigs];
        const count = response.headers['pagination-total-count'] || 0;

        if (!isMounted) return;
        setHasMoreFeaturedMatches(+count > 5);
        setFeaturedMatchList(data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

    return () => (isMounted = false);
  }, []);

  return (
    <Matches
      gigs={featuredMatchList}
      updateGig={updateFeaturedMatchGig}
      title={`Featured ${isBuyer ? 'Gigs' : 'Match'}`}
      link="discover/featured"
      hasMore={hasMoreFeaturedMatches}
      isLoading={isLoading}
      isPerfectMatch
      featuredGigs
    />
  );
};

export default FeaturedMatches;
